// @ts-ignore
/* eslint-disable */
import request from '../../utils/request';

/** 获取预警模板列表 GET /stock-alert/rule/list */
export async function stockAlertRuleListUsingGET(options?: { [key: string]: any }) {
  return request<API.BaseResultListStockAlertRuleDetailResp>('/stock-alert/rule/list', {
    method: 'GET',
    ...(options || {}),
  });
}

/** 批量创建预警订阅 POST /stock-alert/subscription/create */
export async function stockAlertSubscriptionCreateUsingPOST(
  body: API.StockAlertSubscriptionBatchCreateReq,
  options?: { [key: string]: any },
) {
  return request<API.BaseResultVoid>('/stock-alert/subscription/create', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data: body,
    ...(options || {}),
  });
}

/** 批量删除预警订阅 POST /stock-alert/subscription/delete */
export async function stockAlertSubscriptionDeleteUsingPOST(
  body: API.StockAlertBatchDeleteReq,
  options?: { [key: string]: any },
) {
  return request<API.BaseResultVoid>('/stock-alert/subscription/delete', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data: body,
    ...(options || {}),
  });
}

/** 获取某股票所有预警订阅 GET /stock-alert/subscription/list */
export async function stockAlertSubscriptionListUsingGET(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.stockAlertSubscriptionListUsingGETParams,
  options?: { [key: string]: any },
) {
  return request<API.BaseResultListStockAlertSubscriptionDetailResp>(
    '/stock-alert/subscription/list',
    {
      method: 'GET',
      params: {
        ...params,
      },
      ...(options || {}),
    },
  );
}

/** 编辑单条预警订阅 POST /stock-alert/subscription/update */
export async function stockAlertSubscriptionUpdateUsingPOST(
  body: API.StockAlertSubscriptionUpdateReq,
  options?: { [key: string]: any },
) {
  return request<API.BaseResultVoid>('/stock-alert/subscription/update', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data: body,
    ...(options || {}),
  });
}

/** 获取股票预警触发记录 GET /stock-alert/trigger-record/list */
export async function stockAlertTriggerRecordListUsingGET(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.stockAlertTriggerRecordListUsingGETParams,
  options?: { [key: string]: any },
) {
  return request<API.PageResultListStockAlertTriggerRecordDetailResp>(
    '/stock-alert/trigger-record/list',
    {
      method: 'GET',
      params: {
        ...params,
      },
      ...(options || {}),
    },
  );
}
